import { gsap, ScrollTrigger } from "@/composeables/gsap"

function createSectionAnimation(section) {
    const qs = gsap.utils.selector(section)
    const media = qs('.media img')

    const direction = 1
    const percent = 30
    const scale = 1.6

    gsap.set(media, { willChange: "transform" })

    const tween = gsap.fromTo(
        media,
        {
            y: (1 * direction * percent) + '%',
            scale: scale,
        },
        {
            y: (-1 * direction * percent) + '%',
            scale: scale,
            ease: "none",
      }
    )

    ScrollTrigger.create({
        trigger: section,
        markers: false,
        start: "top bottom",
        end: "bottom top",
        invalidateOnRefresh: true,
        scrub: true,
        animation: tween,
    })
}

export const init = () => {
    const sections = gsap.utils.toArray('.section-text-media[data-effect="parallax"]')

    sections
        .forEach(createSectionAnimation);
}

export default init;
